<template>
    <div class="relative">
        <div class="w-full overflow-y-scroll border-4 border-black rounded-xl wrapper-scrollable">
            <editor-content :editor="editor" />
        </div>
        <textarea
            v-show="showHTML"
            v-model="currentValue"
            class="absolute right-0 overflow-y-scroll border-0 resize-none bottom-1 left-1 top-12 focus:outline-hidden focus:ring-transparent mr-[1px]"
        />
    </div>
</template>

<script setup lang="ts">
import { useEditor, EditorContent } from '@tiptap/vue-3';
import type { FieldComponent } from '@src/Common/Components/types';
import StarterKit from '@tiptap/starter-kit';
import { onBeforeUnmount, ref, Ref, watch } from 'vue';
import { Markdown } from 'tiptap-markdown';

const emit = defineEmits<{
    (event: 'update:modelValue', content: string): void;
}>();

const showHTML: Ref<boolean> = ref(false);

const props = withDefaults(defineProps<FieldComponent>(), {
    modelValue: '',
    dusk: 'tiptap-editor',
});

const currentValue = ref(props.modelValue);

const editor = useEditor({
    content: currentValue.value,
    editorProps: {
        attributes: {
            dusk: props.dusk,
            class: 'prose prose-sm m-5 focus:outline-hidden h-full dark:text-zinc-100',
        },
    },
    extensions: [StarterKit.configure(), Markdown],
    onUpdate: () => {
        emit('update:modelValue', editor.value.storage.markdown.getMarkdown());
    },
});

onBeforeUnmount(() => {
    editor.value.destroy();
});

watch(
    props,
    () => {
        emit('update:modelValue', props.modelValue);
    },
    { deep: true },
);
</script>
